/**
 * Edit RSVP (Sam's B, 2026-11-04): tapping Going - a tile's ✓ or the event page's Going - opens this instead of leaving
 * at once. The Going with sheet's two tall glass choices (the RSVP flow you joined through), Going selected; Save with
 * Not going leaves, through the same path as before (in a group, its Leave this event? still names the groups).
 */
import { useEffect, useState } from 'react';
import { Check, X } from 'lucide-react';
import Modal, { ModalBody, ModalFooter } from '../ui/Modal';
import Button from '../ui/Button';

const CHOICES = [
  { going: true, label: 'Going', Icon: Check },
  { going: false, label: 'Not going', Icon: X },
];

export default function EditRsvpSheet({ isOpen, onClose, onNotGoing }) {
  const [going, setGoing] = useState(true);
  useEffect(() => {
    if (isOpen) setGoing(true);
  }, [isOpen]);
  if (!isOpen) return null;
  const save = () => {
    if (going) onClose?.();
    else onNotGoing?.();
  };
  return (
    <Modal isOpen={isOpen} onClose={onClose} title="Edit RSVP" size="sm">
      <ModalBody>
        <div className="grid grid-cols-2 gap-2.5" role="radiogroup" aria-label="Edit RSVP">
          {CHOICES.map(({ going: value, label, Icon }) => {
            const on = going === value;
            return (
              <button
                key={label}
                type="button"
                role="radio"
                aria-checked={on}
                onClick={() => setGoing(value)}
                className={`flex min-h-[116px] flex-col items-center justify-center gap-2.5 rounded-btn font-semibold ${on ? 'btn-glass-accent' : 'btn-glass-neutral'}`}
              >
                <Icon className="h-7 w-7" aria-hidden="true" />
                <span>{label}</span>
              </button>
            );
          })}
        </div>
      </ModalBody>
      <ModalFooter align="stack">
        <Button fullWidth onClick={save}>
          Save
        </Button>
      </ModalFooter>
    </Modal>
  );
}
